import "./Aldaram.css";

const AldaramPage = () => {
  return (
    <iframe
      src="https://btvrprojects.s3.ap-south-1.amazonaws.com/Aldar_Amenities/index.htm"
      allow="xr-spatial-tracking; vr; fullscreen"
      className="iframe-fullscreen"
    ></iframe>
  );
};

export default AldaramPage;
